'use strict';
import * as $j_app$002edata$002etypes$005fdrug$0024package$0024$002dE$002dP$002dS$002dCode$0024 from "./app.data.types_drug$package$-E-P-S-Code$.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$64() {
}
export { $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$64 as $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$64 };
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$64.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$64.prototype.constructor = $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$64;
/** @constructor */
function $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$64() {
}
export { $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$64 as $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$64 };
$h_Lapp_api_DrugRequestsAcceptedListItem$$anon$64.prototype = $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$64.prototype;
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$64.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$64.prototype.apply__Lsttp_tapir_Schema = (function() {
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_prelude_newtype\uff3ftapir$package$();
  var \u03b4proxy34 = $j_app$002edata$002etypes$005fdrug$0024package$0024$002dE$002dP$002dS$002dCode$0024.$m_Lapp_data_types\uff3fdrug$package$EPSCode$();
  return $x_1.newTypeSchema__Lyantl_INewtype__Lsttp_tapir_Schema__Lsttp_tapir_Schema(\u03b4proxy34, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_schemaForString);
});
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$64.prototype.apply__O = (function() {
  return this.apply__Lsttp_tapir_Schema();
});
var $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$64 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_DrugRequestsAcceptedListItem$$anon$64, "app.api.DrugRequestsAcceptedListItem$$anon$64", ({
  Lapp_api_DrugRequestsAcceptedListItem$$anon$64: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$64 as $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$64 };
//# sourceMappingURL=app.api.-Drug-Requests-Accepted-List-Item$$anon$64.js.map
